import type { ParsedPersonalMessage } from '@module/types/centrifuge/messageTypes';
import {
  isPersonalOverLapLoginMessage,
  type PersonalOverLapLoginMessage,
} from '@module/types/centrifuge/personalMessageTypes';
import { createBlindOnUpdate } from '../../messageUpdates';
import type { MessageHandler, MessageHandlerAction, MessageHandlerContext } from '../types';

export class PersonalOverlapLoginHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<PersonalOverLapLoginMessage>) {}

  canHandle(payload: ParsedPersonalMessage): boolean {
    return isPersonalOverLapLoginMessage(payload);
  }

  async handle(payload: PersonalOverLapLoginMessage, context: MessageHandlerContext): Promise<void> {
    if (this.customAction === null || this.customAction === undefined) return;

    if (!context.playInfo) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context.disconnectSocket?.();
    context.setPlayInfo(createBlindOnUpdate(payload, context.playInfo));
    context.dispose?.();

    const message = payload.data.message.message;

    if (context.hsms) {
      const result = await context.hsms.openModal(
        'Confirm',
        { title: message, isShowCancelButton: false, confirmText: '確認' },
        { size: 'mid' },
      );
      if (result.status === 'confirm') {
        context.router?.push('/');
      }
    } else if (context.pushModal) {
      context.pushModal({
        type: 'CONFIRM_MODAL',
        id: 'PersonalOverlapLogin',
        options: {
          description: message,
          onClose: () => {
            if (window.location.href.includes('broadcast')) {
              window.close();
            }
            context.clearModals?.();
            context.router?.push('/');
          },
        },
      });
    }
  }
}
